import React, { FC } from "react";
import crossgym1_memberships from "../data/crossgym1_memberships";
import crossgym2_memberships from "../data/crossgym2_memberships";
import crossgym3_memberships from "../data/crossgym3_memberships";

const MembershipsSection: FC = () => {
    return (
        <section className="memberships" id="memberships">
            <h3 className="memberships__title">Абонементи</h3>
            <div className="memberships__address">
                <div className="memberships__address-card">
                    <div className="address">
                        <h3>бул. вечірній</h3>
                    </div>
                    <table className="table">
                        <tbody>
                            {crossgym1_memberships.map((item) => (
                                <tr key={item.title}>
                                    <td>{item.title}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="memberships__address-card">
                    <div className="address">
                        <h3>Соцмісто</h3>
                    </div>
                    <table className="table">
                        <tbody>
                            {crossgym2_memberships.map((item) => (
                                <tr key={item.title}>
                                    <td>{item.title}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="memberships__address-card">
                    <div className="address">
                        <h3>Східний-2</h3>
                    </div>
                    <table className="table">
                        <tbody>
                            {crossgym3_memberships.map((item) => (
                                <tr key={item.title}>
                                    <td>{item.title}</td>
                                    <td>{item.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    );
};

export default MembershipsSection;
